import React from 'react';
import { FullPageError, FullPageErrorDescription, FullPageErrorTitle } from '@cko/primitives';
export const NotFound = () => (React.createElement(React.Fragment, null,
    React.createElement(FullPageError, null,
        React.createElement(FullPageErrorTitle, null, "Not found"),
        React.createElement(FullPageErrorDescription, null, "Check the URL and try again."))));
